var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tabs',{attrs:{"type":"border-card"}},[_c('el-tab-pane',{attrs:{"label":"充电订单"}},[_c('recharge-order')],1),_c('el-tab-pane',{attrs:{"label":"停车订单"}},[_c('parking-order')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }